/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SWOTTopicVote'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SWOTTopicVote'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SWOTTopicVoteBatchReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SWOTTopicVote);
  }
}(this, function(ApiClient, SWOTTopicVote) {
  'use strict';




  /**
   * The SWOTTopicVoteBatchReport model module.
   * @module model/SWOTTopicVoteBatchReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SWOTTopicVoteBatchReport</code>.
   * @alias module:model/SWOTTopicVoteBatchReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>SWOTTopicVoteBatchReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SWOTTopicVoteBatchReport} obj Optional instance to populate.
   * @return {module:model/SWOTTopicVoteBatchReport} The populated <code>SWOTTopicVoteBatchReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Votes')) {
        obj['Votes'] = ApiClient.convertToType(data['Votes'], [SWOTTopicVote]);
      }
      if (data.hasOwnProperty('TopicID')) {
        obj['TopicID'] = ApiClient.convertToType(data['TopicID'], 'Integer');
      }
      if (data.hasOwnProperty('DateStarted')) {
        obj['DateStarted'] = ApiClient.convertToType(data['DateStarted'], 'Date');
      }
      if (data.hasOwnProperty('DateClosed')) {
        obj['DateClosed'] = ApiClient.convertToType(data['DateClosed'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/SWOTTopicVote>} Votes
   */
  exports.prototype['Votes'] = undefined;
  /**
   * @member {Integer} TopicID
   * @default 0
   */
  exports.prototype['TopicID'] = 0;
  /**
   * @member {Date} DateStarted
   */
  exports.prototype['DateStarted'] = undefined;
  /**
   * @member {Date} DateClosed
   */
  exports.prototype['DateClosed'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


